import PropTypes from "prop-types";
import StatusChip from "@components/ui-components/status-chip";
import { formatDate } from "@src/utility/helpers/date";
import { formatCurrency } from "@src/utility/helpers/utils";
import { PAYOUT_LABEL, PAYOUT_TONE } from "@src/utility/constants/panel/common";
import DetailRow from "./detail-row";
import SectionCard from "./section-card";

const PublisherInfoCard = ({ publisher, brands }) => {
    const pending = publisher.earnings_pending ?? publisher.pending_amount;
    return (
        <SectionCard title="Publisher">
            <dl className="-my-2.5 divide-y divide-gray-200">
                <DetailRow label="Email">{publisher.email || "—"}</DetailRow>
                <DetailRow label={brands.length > 1 ? "Brands" : "Brand"}>{brands.join(", ") || "—"}</DetailRow>
                {publisher.payout_status && (
                    <DetailRow label="Payout">
                        <StatusChip tone={PAYOUT_TONE[publisher.payout_status] || "neutral"} label={PAYOUT_LABEL[publisher.payout_status] || publisher.payout_status} />
                    </DetailRow>
                )}
                {pending !== undefined && <DetailRow label="Earnings pending">{formatCurrency(pending)}</DetailRow>}
                {publisher.registered_at && <DetailRow label="Registered">{formatDate(publisher.registered_at)}</DetailRow>}
            </dl>
        </SectionCard>
    );
};

PublisherInfoCard.propTypes = {
    publisher: PropTypes.object.isRequired,
    brands   : PropTypes.arrayOf(PropTypes.string).isRequired
};

export default PublisherInfoCard;
